import {
  ExportTemplatePresetValue,
  TransformedData,
} from '@aibees/elephant/components/export-dialog';
import { EnrichmentContent, EnrichmentTypeEnum } from '@aibees/elephant/types';
import { Label } from '@aibees/elephant/types/label';
import {
  EnrichmentFolder,
  EnrichmentOptionTypeEnum,
  ParsedPreset,
  Preset,
  UserRelation,
} from '@aibees/shared/definition';
import { UseBoolean } from '@aibees/shared/hooks';
import { ParseResult } from 'papaparse';
import type { Dispatch, PropsWithChildren, SetStateAction } from 'react';

export interface CreateEnrichmentContextData {
  dialogType: CREATE_DIALOG_TYPE | null;
  previousDialogType: CREATE_DIALOG_TYPE | null;
  handleOpenDialog: (type: CREATE_DIALOG_TYPE) => void;
  handleOpenExitConfirmation: () => void;
  handleCancelExit: () => void;
  handleCloseDialog: () => void;
  enrichmentType?: EnrichmentTypeEnum;
  handleSelectEnrichmentType: (type: EnrichmentTypeEnum) => void;
  isCreatingEnrichment: boolean;
  selectedFile: any;
  handleSelectFile: (file: any) => void;
  selectedColumn: string;
  handleSelectColumn: (selectedColumn: string) => void;
  csvData: ParseResult<RowData> | undefined;
  setCsvData: Dispatch<SetStateAction<ParseResult<RowData> | undefined>>;
  csvDataRows: number;
  creditCost: number;
  isEditTemplate: boolean;
  isEditFolder: boolean;
  setCreditCost: Dispatch<SetStateAction<number>>;
  creditUsageRate: number;
  setCreditUsageRate: Dispatch<SetStateAction<number>>;
  exportTemplateDialog: UseBoolean;
  exportDeleteTemplateDialog: UseBoolean;
  exportDeleteFolderDialog: UseBoolean;
  exportAddFolderDialog: UseBoolean;
  templateName: string;
  item: Pick<Preset, 'id' | 'refId'> | undefined;
  handleSetTemplateName: (name: string) => void;
  handleSetItem: (item: Pick<Preset, 'id' | 'refId'> | undefined) => void;
  handleSetTemplateDialogMode: (mode: boolean) => void;
  folder: EnrichmentFolder | undefined;
  handleSetFolder: (folder: EnrichmentFolder | undefined) => void;
  handleSetFolderDialogMode: (mode: boolean) => void;
  mappedCsvData: EnrichmentContent[];
  setMappedCsvData: Dispatch<SetStateAction<EnrichmentContent[]>>;
  uploadedFileName: string;
  setUploadedFileName: Dispatch<SetStateAction<string>>;
  handleConfirmEnrich: () => void;
  canConfirmEnrich: boolean;
  selectedTemplate: ParsedPreset<ExportTemplatePresetValue> | null;
  setSelectedTemplate: (
    template: ParsedPreset<ExportTemplatePresetValue> | null
  ) => void;
  exportSetting: TransformedData | undefined;
  activeOptions: EnrichmentOptionTypeEnum[];
  handleToggleOption: (
    optionType: EnrichmentOptionTypeEnum,
    isActive: boolean
  ) => void;
  overwriteOwner: boolean;
  handleSetOverwriteOwner: (value: boolean) => void;
  selectedUser: UserRelation | undefined;
  handleSetUser: (user: UserRelation | undefined) => void;
  selectedLabels: Label[];
  handleSetLabels: (labels: Label[]) => void;
  selectedLists: Label[];
  handleSetLists: (lists: Label[]) => void;
  rowsLimitReached: boolean;
}

export interface RowData {
  [key: string]: string;
}

export interface CreateEnrichmentContextProps extends PropsWithChildren {
  value?: CreateEnrichmentContextData;
}

export enum CREATE_DIALOG_TYPE {
  SELECT_TYPE = 'SELECT_TYPE',
  SELECT_EMAILENRICHMENT_TYPE = 'SELECT_EMAILENRICHMENT_TYPE',
  PROCESSING_CSV = 'PROCESSING_CSV',
  PREVIEW_DATA = 'PREVIEW_DATA',
  CONFIRM_ENRICH = 'CONFIRM_ENRICH',
  INSUFFICIENT_CREDITS = 'INSUFFICIENT_CREDITS',
  TEMPLATE_MANAGEMENT = 'TEMPLATE_MANAGEMENT',
  ADD_FOLDER = 'ADD_FOLDER',
  EXIT_CONFIRMATION = 'EXIT_CONFIRMATION',
}
